import React, { useState } from 'react';
import Header from './Header';
import BottomNavigation from './BottomNavigation';

function Messages() {
  const [selectedConversation, setSelectedConversation] = useState(null);

  // Sample message data
  const conversations = [
    {
      id: 1,
      contact: "Detective Sarah Collins",
      role: "Lead Detective's Deputy",
      lastMessage: "Update on the forensics report",
      timestamp: "14:30",
      unread: 2,
      messages: [
        { id: 1, sender: "them", text: "Update on the forensics report", time: "14:30" },
        { id: 2, sender: "them", text: "We found traces of fabric under her nails", time: "14:32" },
        { id: 3, sender: "me", text: "What type of fabric?", time: "14:35" },
        { id: 4, sender: "them", text: "Still analyzing, will let you know", time: "14:30" }
      ]
    },
    {
      id: 2,
      contact: "Sophie Renshaw",
      role: "Victim's Best Friend",
      lastMessage: "I need to speak with you urgently",
      timestamp: "13:45",
      unread: 0,
      messages: [
        { id: 1, sender: "them", text: "I need to speak with you urgently", time: "13:45" },
        { id: 2, sender: "me", text: "What's the matter?", time: "13:50" },
        { id: 3, sender: "them", text: "It's about Laura. I remembered something", time: "13:52" }
      ]
    },
    {
      id: 3,
      contact: "Daniel Price",
      role: "Victim's Boyfriend",
      lastMessage: "Can we meet tomorrow?",
      timestamp: "12:20",
      unread: 1,
      messages: [
        { id: 1, sender: "them", text: "Can we meet tomorrow?", time: "12:20" },
        { id: 2, sender: "me", text: "What time works for you?", time: "12:25" }
      ]
    },
    {
      id: 4,
      contact: "PC Sam Carter",
      role: "Scene Officer",
      lastMessage: "Scene photos uploaded to database",
      timestamp: "11:30",
      unread: 0,
      messages: [
        { id: 1, sender: "them", text: "Scene photos uploaded to database", time: "11:30" },
        { id: 2, sender: "me", text: "Thanks, reviewing now", time: "11:35" }
      ]
    }
  ];

  const handleConversationOpen = (conversation) => {
    // Mark messages as read when conversation is opened
    conversation.unread = 0;
    setSelectedConversation(conversation);
  };

  if (selectedConversation) {
    const conversation = conversations.find(c => c.id === selectedConversation.id);
    
    return (
      <div className="messages-container">
        <Header 
          showBackButton={true} 
          onBack={() => setSelectedConversation(null)}
        />
        
        <div className="conversation-header">
          <div className="conversation-contact-info">
            <div className="conversation-avatar">
              {conversation.contact === "Detective Sarah Collins" ? (
                <img 
                  src="/story/the-missing-hour/images/sarah_collins.jpg" 
                  alt={conversation.contact}
                  className="conversation-profile-photo"
                />
              ) : (
                conversation.contact.split(' ').map(n => n[0]).join('')
              )}
            </div>
            <div className="conversation-details">
              <h3>{conversation.contact}</h3>
            </div>
          </div>
        </div>

        <div className="conversation-messages">
          {conversation.messages.map(message => (
            <div key={message.id} className={`message-bubble ${message.sender}`}>
              <div className="message-text">{message.text}</div>
              <div className="message-time">{message.time}</div>
            </div>
          ))}
        </div>

        <BottomNavigation showNavigation={true} />
      </div>
    );
  }

  return (
    <div className="messages-container">
      <Header />
      
      <div className="messages-title-section">
        <h2>Messages</h2>
      </div>

      <div className="conversations-list">
        {conversations.map(conversation => (
          <div 
            key={conversation.id} 
            className={`conversation-item ${conversation.unread > 0 ? 'has-unread' : ''}`}
            onClick={() => handleConversationOpen(conversation)}
          >
            <div className="conversation-avatar">
              {conversation.contact === "Detective Sarah Collins" ? (
                <img 
                  src="/story/the-missing-hour/images/sarah_collins.jpg" 
                  alt={conversation.contact}
                  className="conversation-profile-photo"
                />
              ) : (
                conversation.contact.split(' ').map(n => n[0]).join('')
              )}
            </div>
            
            <div className="conversation-content">
              <div className="conversation-header-row">
                <div className="conversation-name">{conversation.contact}</div>
                <div className="conversation-time">{conversation.timestamp}</div>
              </div>
              
              <div className="conversation-preview">
                <span className="conversation-message">{conversation.lastMessage}</span>
                {conversation.unread > 0 && (
                  <span className="unread-badge">{conversation.unread}</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <BottomNavigation showNavigation={true} />
    </div>
  );
}

export default Messages;
